import React from 'react';
import NumberFormat from 'react-number-format';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import TextField from 'material-ui/TextField';

const InsuranceStep = ({ fields, assignRef, onInputKeyDown }) => (
  <div className="step-content">
    <h2>Tryggingargjald</h2>
    <p>Ef tilvonandi leigjandi rústar íbúðinni er gott að vera með smá tryggingargjald.</p>
    <div className="input-wrapper insurance-input">
      <TextField
        value={fields.insuranceAmount.value}
        ref={assignRef ? c => assignRef('insuranceAmount', c) : null}
        onKeyDown={onInputKeyDown}
        pattern="[0-9]*" type="number"
        min="0" hintText="600.000"
        fullWidth
      >
        <NumberFormat {...fields.insuranceAmount} thousandSeparator="." />
      </TextField>
      <span>kr.</span>
    </div>
    <p className="second-text">Hvernig viltu ganga frá tryggingargjaldinu?</p>
    <RadioButtonGroup {...fields.insuranceType} name="insuranceType" className="radio-button-wrapper" defaultSelected="Samkomulag">
      <RadioButton value="Samkomulag" label="Samkomulag" />
      <RadioButton value="Bankaábyrgð" label="Bankaábyrgð" />
    </RadioButtonGroup>
  </div>
);

InsuranceStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  assignRef: React.PropTypes.func,
  onInputKeyDown: React.PropTypes.func,
};

export default InsuranceStep;



// WEBPACK FOOTER //
// ./src/browser/steps/InsuranceStep/InsuranceStep.js